export default () => ({
  settings: {}
})
